export const protectedRoutes = {
  PROFILE: '/account-settings',
  TWO_FACTOR_AUTHENTICATION: '/account-settings/two-factor-authentication'
};

export const VERIFY_OTP_MODAL = {
  title: 'Enter the OTP code',
  desc: {
    email: 'A 6 digit OTP code has been sent to your email address.',
    app: 'A 6 digit OTP code has been sent to your authenticator app.'
  },
  errorMessage: 'The OTP code is invalid or expired.',
  btText: 'Confirm'
};

export const GOOGLE_AUTHENTICATION_APP =
  'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US';
export const IOS_AUTHENTICATION_APP =
  'https://apps.apple.com/us/app/authenticator-app/id1538761576';

export const PROFILE_TYPE_MODAL = {
  SUCCESS: 'success',
  VERIFY_PASSWORD: 'verify-password',
  VERIFY_OTP: 'verify-otp',
  PENDING_RECOVERY_EMAIL: 'pending-recovery-email',
  SOMETHING_WRONG: 'something-wrong',
  VERIFY_SUCCESS: 'verify-success'
};

export const PROFILE_MODAL = {
  SUCCESS: {
    TITLE: 'Profile updated successfully',
    CONFIRM: 'Done'
  },
  VERIFY_PASSWORD: {
    TITLE: 'Enter your password',
    DESC: 'For security, enter your password to verify your recovery email.',
    LABEL: 'Password',
    PLACEHOLDER: 'Enter confirm password',
    CONFIRM: 'Next'
  },
  VERIFY_OTP: {
    TITLE: 'Verify Email Address',
    DESC: 'A 6 digit OTP code has been sent to your email address, kindly type in the code to verify your address and proceed',
    CONFIRM: 'Next'
  },
  VERIFY_RECOVERY_EMAIL: {
    TITLE: 'Verify Recovery Email',
    DESC: 'A 6 digit OTP code has been sent to your email address, kindly type in the code to verify your address and proceed',
    CONFIRM: 'Next'
  },
  PENDING_RECOVERY_EMAIL: {
    TITLE: 'Verification pending',
    DESC: "We noticed you haven't verified your recovery email address yet. Please verify your email before clicking Update Profile.",
    CONFIRM: 'Verify now'
  },
  SOMETHING_WRONG: {
    TITLE: 'Something went wrong',
    CONFIRM: 'Okay'
  },
  VERIFY_SUCCESS: {
    TITLE: 'Email verified successfully',
    CONFIRM: 'Done'
  },
  CONNECT_SUCCESS: {
    TITLE: 'Connect wallet successfully',
    CONFIRM: 'Done'
  },
  DISCONNECT_SUCCESS: {
    TITLE: 'Are you sure you want to disconnect your crypto wallet?',
    DESC: 'Warning: This will unsync your NFTs from the wallet.',
    CONFIRM: 'Disconnect'
  }
};

export const PROFILE_ERROR_MESSAGE = {
  SOMETHING: 'Something went wrong',
  OTP: 'The OTP code is invalid or expired'
};
